export const DocumentsActionTypes = {
    API_RESPONSE_SUCCESS: '@@documents/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR: '@@documents/API_RESPONSE_ERROR',

    // Documents
    GET_DOCUMENTS: '@@documents/GET_DOCUMENTS',
    GET_DOCUMENT: '@@documents/GET_DOCUMENT',
    GET_DOCUMENTS_BY_TRANSACTION: '@@documents/GET_DOCUMENTS_BY_TRANSACTION',
    GET_DOCUMENTS_BY_TRANSACTIONS: '@@documents/GET_DOCUMENTS_BY_TRANSACTIONS',
    GET_DOCUMENTS_BY_LISTING: '@@documents/GET_DOCUMENTS_BY_LISTING',
    GET_DOCUMENTS_BY_OWNER: '@@documents/GET_DOCUMENTS_BY_OWNER',

    CREATE_DOCUMENT: '@@documents/CREATE_DOCUMENT',
    UPDATE_DOCUMENT: '@@documents/UPDATE_DOCUMENT',
    DELETE_DOCUMENT: '@@documents/DELETE_DOCUMENT',
};
